module.exports = "<div class=\"auth-callback-container\"></div>\r\n<div id=\"loader-container\"></div>\r\n";